import { ProfessionIcon } from './profession-icon';

export const IconMusic = () => (
  <ProfessionIcon bg="#FFF3E0">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <path
        d="M9 18V5l12-2v13"
        stroke="#FF9800"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="6" cy="18" r="3" stroke="#FF9800" strokeWidth="1.8" />
      <circle cx="18" cy="16" r="3" stroke="#FF9800" strokeWidth="1.8" />
    </svg>
  </ProfessionIcon>
);
